"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _MarginOpenPositionsComponent = _interopRequireDefault(require("./MarginOpenPositionsComponent"));
var _instrumentPositionSelectors = require("../../../redux/selectors/instrumentPositionSelectors");
var _selectors = require("../../../redux/margin/selectors");
var _modalActions = require("../../../redux/actions/modalActions");
var _productsSelectors = require("../../../redux/selectors/productsSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var openPositions = (0, _selectors.openPositionsSelector)(state, ownProps.config);
  var instruments = (0, _instrumentPositionSelectors.instrumentSelectorInstruments)(state);
  var notionalProduct = (0, _productsSelectors.baseNotionalProductSelector)(state);
  var activeRequests = state.margin.history.activeRequests;
  var fetching = activeRequests > 0;
  return {
    data: openPositions,
    instruments: instruments,
    notionalProduct: notionalProduct,
    fetching: fetching
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openClosePositionModal: function openClosePositionModal(position, action) {
      return dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.MARGIN_CLOSE_POSITION, {
        position: position,
        action: action
      }));
    },
    openRepayLoanModal: function openRepayLoanModal(position, action) {
      return dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.MARGIN_REPAY_LOAN, {
        position: position,
        action: action
      }));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_MarginOpenPositionsComponent["default"]);